<template>
	<section class="pc-card">
		<h2 class="pc-card-title">老師服務</h2>
		<ul>
			<li v-for="item in data" :key="item.id" @click="toService(item)">
				<van-image class="bg" :src="item.background_image || defaultImg" alt="" />
				<div class="info">
					<p class="nickname">
						{{ item.name }}
					</p>
					<p class="desc">{{ item.detail }}</p>
					<div class="price-box">
						<div class="price">
							<img src="~/assets/images/pc/coin.png" alt="" />
							<span class="price-text">{{ item.final_price }}</span>
						</div>
						<div
							class="btn"
							v-show="teacherInfo?.big_teacher_assistant_str != 0"
							@click.stop="toChat"
						>
							免費提問
						</div>
					</div>
				</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
import defaultImg from "~/assets/images/default.png";
import { logEvent } from "~/utils/firebase";
import { inject } from "vue";

const openLogin = inject("openLogin");
const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	teacherId: {
		type: String,
		default: "",
	},
	teacherInfo: {
		type: Object,
		default: () => ({}),
	},
	chatEvent: {
		type: String,
		default: "",
	},
});

const toService = item => {
	navigateTo(`/seer/teacher-service/${props.teacherId}/${item.id}`);
};
const toChat = () => {
	if (import.meta.client) {
		logEvent(props.chatEvent);
	}
	openLogin();
	navigateTo(`/seer/chat/${props.teacherInfo.big_teacher_assistant_str}`);
};
</script>

<style lang="scss" scoped>
.pc-card {
	padding: 0 63px;
	width: 100%;
	font-family: PingFang SC;

	.pc-card-title {
		margin: 12px 20px 0;
		font-weight: 400;
		font-size: 32px;
		color: #1f2329;
	}

	ul {
		display: flex;
		flex-wrap: wrap;
		margin-top: 24px;

		li {
			width: 275px;
			margin-right: 16px;
			margin-bottom: 16px;
			display: flex;
			flex-direction: column;
			align-items: center;
			background-color: #ffffff;
			border-radius: 8px;
			cursor: pointer;
			overflow: hidden;

			&:nth-child(4n) {
				margin-right: 0;
			}

			.bg {
				width: 275px;
				height: 275px;
				object-fit: cover;
			}

			.info {
				flex: 1;
				margin-top: 13px;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 13px 14px;

				.nickname {
					margin-bottom: 7px;
					width: 100%;
					font-weight: 500;
					font-size: 24px;
					color: #333333;
					line-height: 28px;
				}

				.desc {
					margin-bottom: 13px;
					font-weight: 400;
					font-size: 18px;
					color: #646a73;
					line-height: 27px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.price-box {
					width: 250px;
					margin-top: auto;
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #83570e;

					.price {
						display: flex;
						align-items: flex-end;

						img {
							margin-right: 2px;
							width: 28px;
							height: 28px;
						}

						.price-text {
							font-family: DIN Alternate;
							font-weight: bold;
							font-size: 26px;
							line-height: 28px;
						}
					}

					.btn {
						width: 108px;
						height: 40px;
						font-weight: 400;
						font-size: 18px;
						color: #ffffff;
						line-height: 40px;
						text-align: center;
						background: linear-gradient(78deg, #da9b60 0%, #bb712d 100%);
						border-radius: 3px 3px 3px 3px;
					}
				}
			}
		}
	}
}
</style>
